export default "__VITE_ASSET__CxIZ1BjE__"